import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthRedirectComponent } from './auth-redirect.component';

@NgModule({
  declarations: [AuthRedirectComponent],
  imports: [RouterModule],
})
export class AuthRedirectModule {}
